import { render, staticRenderFns } from "./IconCardAmex.vue?vue&type=template&id=47f464d5&"
import script from "./IconCardAmex.vue?vue&type=script&lang=js&"
export * from "./IconCardAmex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f464d5')) {
      api.createRecord('47f464d5', component.options)
    } else {
      api.reload('47f464d5', component.options)
    }
    module.hot.accept("./IconCardAmex.vue?vue&type=template&id=47f464d5&", function () {
      api.rerender('47f464d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCardAmex.vue"
export default component.exports